class SizeGuideVideo extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.zen-size-guide__overlay');
    this.container = this.querySelector('[data-video-container]');
    this.template = this.querySelector('[data-video-template]');
    this.ctaBtn = this.querySelector('.zen-size-guide__cta');
    this.closeBtn = this.querySelector('.zen-size-guide__close');

    if (!this.overlay || !this.ctaBtn || !this.closeBtn) return;

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
    this.handleBackdropClick = this.handleBackdropClick.bind(this);

    this.ctaBtn.addEventListener('click', this.handleOpen);
    this.closeBtn.addEventListener('click', this.handleClose);
    this.overlay.addEventListener('click', this.handleBackdropClick);
  }

  disconnectedCallback() {
    this.ctaBtn?.removeEventListener('click', this.handleOpen);
    this.closeBtn?.removeEventListener('click', this.handleClose);
    this.overlay?.removeEventListener('click', this.handleBackdropClick);
    document.removeEventListener('keydown', this.handleKeydown);

    if (this.overlay?.parentNode === document.body) {
      document.body.removeChild(this.overlay);
    }
  }

  handleOpen() {
    if (!this.template) return;

    this.triggerEl = document.activeElement;

    const clone = this.template.content.cloneNode(true);
    this.container.appendChild(clone);

    const video = this.container.querySelector('video');
    if (video) {
      video.play();
    }

    document.body.appendChild(this.overlay);
    document.body.classList.add('overflow-hidden');
    this.overlay.classList.add('is-open');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', this.handleKeydown);
    this.closeBtn.focus();
  }

  handleClose() {
    this.overlay.classList.remove('is-open');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', this.handleKeydown);

    const video = this.container.querySelector('video');
    if (video) {
      video.pause();
      video.remove();
    }

    document.body.classList.remove('overflow-hidden');
    this.appendChild(this.overlay);
    this.triggerEl?.focus();
  }

  handleKeydown(event) {
    if (event.key === 'Escape') {
      this.handleClose();
    }
  }

  handleBackdropClick(event) {
    if (event.target === this.overlay) {
      this.handleClose();
    }
  }
}

if (!customElements.get('size-guide-video')) {
  customElements.define('size-guide-video', SizeGuideVideo);
}
